export const getB2BPageName = (pageSlug: string): string =>
  'b2b_' + pageSlug.replace(/^business\//, '').replace(/[-/]/g, '_');
